<template>
    <div>
        
        <Cbtc />
    </div>
</template>

<script>

import Cbtc from '../blog-details/Cbtc.vue'

export default {
    components: {
       
        Cbtc,
    }
}
</script>